import { render } from "./C403Error.vue?vue&type=template&id=5767d846&scoped=true"
const script = {}

import "./C403Error.vue?vue&type=style&index=0&id=5767d846&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5767d846"]])

export default __exports__